import { auth } from "../../firebaseConfig";

async function withAdminAuth(path, options = {}) {
  const user = auth.currentUser;
  if (!user) throw new Error("Not logged in");
  const token = await user.getIdToken();
  const headers = {
    Authorization: `Bearer ${token}`,
    ...(options.headers || {}),
  };
  const res = await fetch(path, { ...options, headers, cache: "no-store" });
  const text = await res.text().catch(() => "");
  let json = null;
  try {
    json = text ? JSON.parse(text) : null;
  } catch {
    json = null;
  }
  if (!res.ok || json?.error === true) {
    const trimmed = String(text || "").trim();
    const looksLikeHtml = /^<!DOCTYPE html>/i.test(trimmed) || /^<html/i.test(trimmed);
    throw new Error(
      json?.message
      || json?.error
      || (looksLikeHtml ? `Server returned an HTML application error for ${path}.` : "")
      || text
      || `Request failed with status ${res.status}`
    );
  }
  return json;
}

export function adminGetJson(path) {
  return withAdminAuth(path, { method: "GET" });
}

export function adminDeleteJson(path) {
  return withAdminAuth(path, { method: "DELETE" });
}

export function adminPostJson(path, body) {
  return withAdminAuth(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
}
